module.exports = __webpack_public_path__ + "static/img/IMG_3802.7d0ae47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG_3802.jpg
// module id = 285
// module chunks = 0